<template>
    <b-card :style="{'max-width': '1024px', 'width': '90%', 'margin-left': 'auto', 'margin-right': 'auto', 'margin-top': '10px'}">
        <b-card-text>
            <h4>Receiving Items</h4>
        </b-card-text>

        <b-card>
            <div v-if="location_counts.length>0" style="display: inline; margin: 5px;">
                <b-button :pressed="location_count.location_id == location_id" variant="outline-dark" v-for="location_count,lcidx in location_counts" style="margin: 5px;" @click="fetch_init(location_count)" v-bind:key="lcidx">{{ packet.locationsdict[location_count.location_id] }} ({{ location_count.cnt }})</b-button>
                
            </div>
            <b-button :pressed="is_warehouse_view" variant="outline-primary" @click="fetch_for_warehouse">Warehouse</b-button>
        </b-card>

        <b-overlay :show="items_being_loaded" spinner-variant="primary" spinner-type="grow" spinner-small rounded="sm">
            <div v-if="items.length > 0" style="margin-top: 10px;">
                <span v-if="is_warehouse_view">
                    COMING TO: Warehouse
                </span>
                <span v-else>
                    <b-card-text>COMING TO: {{ packet.locationsdict[location_id] }}</b-card-text>
                </span>
                <table style="width: 100%;">
                    <thead>
                        <tr>
                            <td class="ipt_tdhr">
                                #
                            </td>
                            <td class="ipt_tdhr">
                                REQUEST DATE
                            </td>
                            <td class="ipt_tdhr">
                                INVOICE #
                            </td>
                            <td class="ipt_tdhr">
                                PRD
                            </td>
                            <td class="ipt_tdhr">
                                QTY
                            </td>

                            <td class="ipt_tdhr">
                                COMING FRM
                            </td>
                            <td class="ipt_tdhr" style="width: 120px;">
                                STATUS
                            </td>

                            <td class="ipt_tdhr" style="width: 150px;">
                                RECEIVED AT
                            </td>
                            
                            <td class="ipt_tdhr">
                                ACTION
                            </td>
                            <!-- <td class="ipt_tdhr">
                                ACTION
                            </td> -->
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="item,idx in items" v-bind:key="idx">
                            <td class="ipt_tdhr" style="font-weight: normal;">
                                {{ idx + 1}}
                            </td>
                            <td class="ipt_tdhr" style="font-weight: normal;">
                                {{ parse_dt(item.delivery_date) }}
                            </td>
                            <td class="ipt_tdhr" style="font-weight: normal;">
                                <div>{{ item.invoice_id }}</div>
                                <div style="font-size: 11px;">
                                    <span v-if="item.order_type == 'home_delivery'">
                                        <b-badge variant="primary">Home Delivery</b-badge>
                                    </span>
                                    <span v-else-if="item.order_type == 'store_pickup'">
                                        <b-badge variant="success">Store Pickup</b-badge>
                                    </span>
                                    <span v-else>
                                        <b-badge variant="secondary">{{item.order_type}}</b-badge>
                                    </span>

                                </div>
                            </td>
                            <td class="ipt_tdhr" style="font-weight: normal;">
                                {{ item.product_sku }}
                                <div><b-badge v-if="item.is_special" variant="warning">SPECIAL</b-badge></div>
                            </td>
                            <td class="ipt_tdhr" style="font-weight: normal;">
                                {{ item.quantity }}
                            </td>

                            <td class="ipt_tdhr" style="font-weight: normal;">
                                <span v-if="item.locsub != null">
                                    <div>{{ packet.locationsdict[parseInt(item.locsub.split("|"))] }}</div>
                                </span>
                            </td>

                            <td class="ipt_tdhr" style="font-weight: normal;">
                                <b-form-select style="font-size: 11px;"  :options="states" v-model="item.state">
                                </b-form-select>
                            </td>

                            <td class="ipt_tdhr">
                                <b-form-select :options="packet.locsubs" v-model="item.currently_at" style="font-size: 10px;"></b-form-select>
                            </td>

                            <td class="ipt_tdhr" style="font-weight: normal;">
                                <b-button size="sm" variant="success" @click="mark_element(item)">UPDATE</b-button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div v-else style="margin-top: 10px;">
                <b-alert show variant="warning">No Items</b-alert>
            </div>
        </b-overlay>
    </b-card>
</template>
<script>
    import moment from 'moment'
    import global_vars from '@/utilities/global_vars'
    import Backer from '@/components/globals/Backer'
    import Requestor from '@/utilities/Requestor'

    export default {
        name: "IncomingOutGoingIncoming",
        components: {Backer},
        data: function(){
            return {
                packet: {},
                items: [],
                items_being_loaded: false,
                global_vars: global_vars,
                location_counts: [],
                location_id: null,
                is_warehouse_view: false,
                states: [
                    {"value": null, "text": "NONE"},
                    {"value": "atpl", "text": "ADDED TO PULLIST"},
                    {"value": "pulled", "text": "PULLED"},
                    {"value": "picked", "text": "PICKED"},
                    {"value": "dropped", "text": "DROPPED"},
                    {"value": "rts", "text": "READY TO SHIP"},
                    {"value": "shipped", "text": "SHIPPED"},
                    {"value": "delivered", "text": "DELIVERED"},
                ],
                states_dict: {
                    null: "NONE",
                    "atpl": "ADDED TO PULLIST",
                    "pulled": "PULLED",
                    "picked": "PICKED",
                    "dropped": "DROPPED",
                    "rts": "READY TO SHIP",
                    "shipped": "SHIPPED",
                    "delivered": "DELIVERED",
                },
                warehouse_location_id: 4,
                update_disabled: false,
            }
        },
        methods: {
            parse_dt: function(dt){
                return moment(dt).format("MM-DD-YYYY")
            },
            fetch_for_warehouse: function(e){
                if (e){
                    e.preventDefault();
                }
                this.location_id = null;
                this.is_warehouse_view = true;
                let that = this;
                let path = "/api/transfers/get_incoming_to_warehouse/"
                let data = {}
                let s = function(response){
                    if (response.data.result){
                        that.items = response.data.result;
                    }
                    else {
                        that.$bvToast.toast(
                            response.data.error, 
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    }
                    that.items_being_loaded = false;
                }
                let f = function(error){
                    console.log(error)
                    that.$bvToast.toast(
                        "Error loading incoming items.",
                        {title: "Error", autoHideDelay: 1500, variant:"warning"}
                    );
                    that.items_being_loaded = false;
                }
                this.items_being_loaded = true;
                this.items = []
                Requestor.postSyncP(path, data, this, s, f);
            },
            fetch_init: function(location_count){
                let location_id = location_count.location_id;
                this.location_id = location_id;
                this.is_warehouse_view = false;
                let that = this;
                let path = "/api/transfers/get_incoming_items/"
                let data = {
                    location_id: location_id,
                }
                let s = function(response){
                    if (response.data.result){
                        that.items = response.data.result;
                    }
                    else {
                        that.$bvToast.toast(
                            response.data.error, 
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    }
                    that.items_being_loaded = false;
                }
                let f = function(error){
                    console.log(error)
                    that.$bvToast.toast(
                        "Error loading incoming items.",
                        {title: "Error", autoHideDelay: 1500, variant:"warning"}
                    );
                    that.items_being_loaded = false;
                }
                this.items_being_loaded = true;
                this.items = []
                Requestor.getSyncP(path, data, this, s, f);
            },
            fetch_prereqs: function(){
                let that = this;
                //let location_id = this.packet.userDetails.properties.location_id;
                let prereqs = [
                    {
                        path:  "/api/transfers/get_incoming_items_count_by_locations/",
                        //data: {location_id: location_id},
                        data: {},
                        type: "",
                        executable: Requestor.getAsync,
                        s: function(response){
                            if (response.data.result){
                                that.location_counts = response.data.result;
                            }
                            else {
                                that.$bvToast.toast(
                                    response.data.error, 
                                    {title: "Error", autoHideDelay: 1500, variant:"warning"}
                                );
                            }
                        },
                        f: function(error){
                            console.log(error)
                            that.$bvToast.toast(
                                "Error loading incoming counts.",
                                {title: "Error", autoHideDelay: 1500, variant:"warning"}
                            );
                        }
                    },
                ]

                for (var i=0; i<prereqs.length; i++){
                    let path = prereqs[i]["path"];
                    let data = prereqs[i]["data"];
                    let s = prereqs[i]["s"];
                    let f = prereqs[i]["f"];
                    let type = prereqs[i]["type"];
                    if (type == "secure"){
                        prereqs[i]["executable"](path, data, this, s, f);   
                    }
                    else {
                        prereqs[i]["executable"](path, data, s, f); 
                    }
                }
            },
            mark_element: function(item){
                let path = "/api/transfers/mark_element/"
                let that = this;
                let state = item.state;
                let data = {invoice_id: item.invoice_id, itemid: item.itemid, state: state, currently_at: item.currently_at}

                let s = function(response) {
                    if (response.data.result){
                        that.$bvToast.toast(
                            "Updated.", 
                            {title: "Success", autoHideDelay: 1500, variant:"success"}
                        );
                        item.pulled_status = "pulled"
                    }
                    else {
                        that.$bvToast.toast(
                            response.data.error, 
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    }
                }

                let f = function(error) {
                    console.log(error)
                    that.$bvToast.toast(
                        "Error marking item. Please try again.",
                        {title: "Error", autoHideDelay: 1500, variant:"danger"}
                    );
                }

                Requestor.postAsyncP(path, data, this, s, f);
            },
        },
        created: function(){
            this.packet = JSON.parse(localStorage.packet);
            this.packet.userDetails = JSON.parse(localStorage.userDetails);
            this.fetch_prereqs()
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/IncomingOutGoing/IncomingOutGoingIncoming.vue